import { supabase } from "../../../supabaseClient";
import { useQuery } from "react-query";
import TaskTile from "../../tasks/components/TaskTile";

export default function TasksFeed() {
  const fetchTasks = async () => {
    try {
      let { data: tasks, error } = await supabase
        .from("tasks")
        .select("*")
        .limit(20)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching tasks:", error);
      } else {
        return tasks;
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const { data: tasks, isLoading, isError } = useQuery("steps", fetchTasks);

  return (
    <div className="mx-auto">
      {isLoading && (
        <div className="space-y-4 px-1 md:px-8">
          {Array.from({ length: 5 }, () => 0).map((x) => (
            <div
              className="skeleton h-40 w-full"
              key={x}
            ></div>
          ))}
        </div>
      )}
      {!isLoading && tasks && (
        <div className="space-y-4 px-1 md:px-8 mb-8">
          <div className="text-sm italic">
            AI is cool, but have you heard of code snippets?
          </div>
          {tasks.map((task) => (
            <TaskTile
              key={task.id}
              task={task}
            />
          ))}
        </div>
      )}
    </div>
  );
}
